import { render, staticRenderFns } from "./Purchase_item.vue?vue&type=template&id=210994b2&scoped=true&"
import script from "./Purchase_item.vue?vue&type=script&lang=js&"
export * from "./Purchase_item.vue?vue&type=script&lang=js&"
import style0 from "./Purchase_item.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Purchase_item.vue?vue&type=style&index=1&id=210994b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210994b2",
  null
  
)

export default component.exports